import React from 'react';

import {SweetReactSelect} from 'app/components/general/SweetReactSelect';
import {
  RECYCLEABLE_CONTENT_TYPES,
  RecycleableContentTypeOptionType,
} from 'app/utils/constants';
import {gt} from 'app/utils/i18n';

const getContentTypeOptions = (
  options: Array<RecycleableContentTypeOptionType>
) =>
  [
    {
      value: '',
      text: gt('All'),
    },
    {
      value: RECYCLEABLE_CONTENT_TYPES.PROCEDURE,
      text: gt('Procedures'),
    },

    {
      value: RECYCLEABLE_CONTENT_TYPES.PROCESS,
      text: gt('Processes'),
    },
    {
      value: RECYCLEABLE_CONTENT_TYPES.POLICY,
      text: gt('Policies'),
    },
    {
      value: RECYCLEABLE_CONTENT_TYPES.QUIZ,
      text: gt('Quizzes'),
    },
    {
      value: RECYCLEABLE_CONTENT_TYPES.PROCEDURE_VERSION,
      text: gt('Procedure Versions'),
    },
    {
      value: RECYCLEABLE_CONTENT_TYPES.PROCESS_VERSION,
      text: gt('Process Versions'),
    },
    {
      value: RECYCLEABLE_CONTENT_TYPES.POLICY_VERSION,
      text: gt('Policy Versions'),
    },
    {
      value: RECYCLEABLE_CONTENT_TYPES.QUIZ_VERSION,
      text: gt('Quiz Versions'),
    },
    {
      value: RECYCLEABLE_CONTENT_TYPES.FOLDER,
      text: gt('Folders'),
    },
    {
      value: RECYCLEABLE_CONTENT_TYPES.ATTEMPT,
      text: gt('Attempts'),
    },
    {
      value: RECYCLEABLE_CONTENT_TYPES.LANE,
      text: gt('Lanes'),
    },
  ].filter((opt) => options.indexOf(opt.value) > -1);

type Props = {
  value: string;
  options: Array<RecycleableContentTypeOptionType>;
  onChange: (value: string) => void;
};

export const DashboardFilterbarContentType = ({
  value,
  options,
  onChange,
}: Props) => {
  const contentTypeOptions = getContentTypeOptions(options);

  const getCurrentValue = (value: string) => {
    return contentTypeOptions.filter((opt) => {
      return value
        ?.split(',')
        .map((v) => v.trim())
        .includes(opt.value);
    });
  };

  return (
    <SweetReactSelect
      isMulti={true}
      isSearchable={true}
      getOptionLabel={(i) => i.text}
      getOptionValue={(i) => i.value}
      placeholder={gt('Filter by type...')}
      options={contentTypeOptions}
      value={getCurrentValue(value)}
      onChange={(cts) => onChange(cts.map((ct) => ct.value).join(','))}
    />
  );
};
